export default __webpack_public_path__ + "static/media/Reputation.1c4c2dc8.svg";